import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React from "react";
import stl from "../../Layout.module.css";
import { useLocation } from "react-router-dom";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { useMemo } from "react";
import { Icon } from "@syarahtech/ui";
import { twMerge } from "tailwind-merge";
import { trackEvents } from "@/common/events/events";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
import UnbxdMobileTextSearch from "@/components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/components/UnbxdTextSearch/UnbxdMobileTextSearch/UnbxdMobileTextSearch";
import { URL_SELL_TRADE_LANDING_v2 } from "@/pages/sell-trade-v2/sell-trade/constants";
var NavItem = function NavItem(_ref) {
  var to = _ref.to,
    icon = _ref.icon,
    label = _ref.label,
    isActive = _ref.isActive,
    action = _ref.action,
    _onClick = _ref.onClick,
    openTextSearchBox = _ref.openTextSearchBox;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !openTextSearchBox && to ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    href: to,
    className: twMerge("gap-2 justify-between text-xs font-medium text-neutral-30", isActive ? "text-primary pointer-events-none font-bold" : ""),
    onClick: function onClick() {
      return _onClick && _onClick();
    }
  }, /*#__PURE__*/React.createElement(Icon, _extends({
    icon: icon,
    width: 6,
    height: 6
  }, isActive ? {
    variant: "primary"
  } : {
    className: "text-neutral-30"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-inherit"
  }, label))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "more-btn",
    onClick: action,
    className: "gap-2 justify-between relative"
  }, openTextSearchBox && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 w-full h-full opacity-0 z-[9]"
  }, /*#__PURE__*/React.createElement(UnbxdMobileTextSearch, {
    referral_location: "bottom_bar"
  })), /*#__PURE__*/React.createElement(Icon, _extends({
    icon: icon,
    width: 6,
    height: 6
  }, isActive ? {
    variant: "primary"
  } : {
    className: "text-neutral-30"
  })), /*#__PURE__*/React.createElement("span", {
    id: "more-menu",
    className: "text-xs text-neutral-30 font-medium"
  }, label))));
};
var NavBar = function NavBar(_ref2) {
  var pageName = _ref2.pageName,
    customStickyButton = _ref2.customStickyButton;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var sellTradeUrl = URL_SELL_TRADE_LANDING_v2;
  var NavBarItems = useMemo(function () {
    return [{
      to: createUrl("/"),
      icon: "material-symbols--home-rounded",
      label: t("home", {
        ns: "web_common"
      }),
      isActive: location.pathname === "/" || location.pathname.includes("home")
    }, {
      to: createUrl("/autos"),
      icon: "material-symbols--search-rounded",
      label: t("search", {
        ns: "web_common"
      }),
      isActive: location.pathname.includes("/autos"),
      openTextSearchBox: true
    }, {
      to: createUrl("/filters#referral_location=Home&browse_variant=bottom_bar&variant_value=cta_all_cars"),
      icon: "material-symbols--directions-car-outline-rounded",
      label: t("cars_2", {
        ns: "web_common"
      }),
      isActive: location.pathname.includes("filters")
    }, {
      to: createUrl(sellTradeUrl),
      icon: "material-symbols--car-tag-outline-rounded",
      label: t("sell_car_2", {
        ns: "web_common"
      }),
      isActive: location.pathname.includes(sellTradeUrl),
      event: function event() {
        return trackEvents("sell_car_started", {
          referral_location: "navigation_bar",
          platform: getPlatformInfo(),
          version: "3"
        });
      }
    }, {
      to: null,
      icon: "material-symbols--more-horiz",
      label: t("more", {
        ns: "web_common"
      }),
      isActive: false,
      action: function action() {
        var _document$querySelect;
        return (_document$querySelect = document.querySelector(".sideMenuToggle")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.click();
      }
    }];
  }, [location.pathname]);
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.botomNavContainer, "m-show pt-4 pb-2"].join(" ")
  }, customStickyButton !== null && customStickyButton !== void 0 ? customStickyButton : /*#__PURE__*/React.createElement(React.Fragment, null, NavBarItems.map(function (item, index) {
    var _item$event;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(NavItem, {
      onClick: (_item$event = item === null || item === void 0 ? void 0 : item.event) !== null && _item$event !== void 0 ? _item$event : undefined,
      key: index,
      to: item.to,
      icon: item.icon,
      label: item.label,
      isActive: item.isActive,
      action: item.action,
      openTextSearchBox: item === null || item === void 0 ? void 0 : item.openTextSearchBox
    }));
  })));
};
export default NavBar;